import { createSlice, PayloadAction } from '@reduxjs/toolkit'

interface SkinTotalState {
  total?: number | undefined
  isLoading: boolean
  error: string | null
}

const initialState: SkinTotalState = {
  isLoading: false,
  error: null,
}

const skinsTotalSlice = createSlice({
  name: 'skinsTotal',
  initialState,
  reducers: {
    setSkinsTotal: (state, action: PayloadAction<number | undefined>) => {
      state.total = action.payload
      state.error = null
      state.isLoading = false
    },
    updateSkinsTotal: (state, action: PayloadAction<number>) => {
      state.total = action.payload
    },
    clearSkinsTotal: (state) => {
      state.total = undefined
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload
    },
    setError: (state, action: PayloadAction<string>) => {
      state.error = action.payload
    },
  },
})

export const { setSkinsTotal, clearSkinsTotal, setLoading, setError, updateSkinsTotal } =
  skinsTotalSlice.actions
export default skinsTotalSlice
